import React from "react";
import { DueItem as DueItemContainer, DueItemHeader, DueItemTitle, DueItemSubtitle, DueItemAmount, CheckboxInput } from "./StyledComponents";

const DueItem = ({
    due,
    isBookingPayment,
    enableDueSelection,
    totalDuesAmount,
    onDueSelection,
    formatDateRange,
    duesLabelMapping
}) => {

    return (
        <DueItemContainer>
            <DueItemHeader>
                <div className="flex-1">
                    <DueItemTitle>
                        {isBookingPayment
                            ? "Booking"
                            : due.title || duesLabelMapping[due.type]}
                    </DueItemTitle>
                    <DueItemSubtitle>
                        {isBookingPayment
                            ? "Initial booking amount"
                            : formatDateRange(due)}
                    </DueItemSubtitle>
                </div>
                <div className="flex items-center gap-3">
                    <DueItemAmount>
                        ₹
                        {isBookingPayment
                            ? totalDuesAmount
                            : due.balance}
                    </DueItemAmount>
                    {enableDueSelection &&
                        !isBookingPayment && (
                            <CheckboxInput
                                type="checkbox"
                                checked={due.selected}
                                onChange={() => onDueSelection(due.id)}
                                className="cursor-pointer"
                            />
                        )}
                </div>
            </DueItemHeader>
        </DueItemContainer>
    );
};

export default DueItem;